import { PostItem } from 'hc-entities';
import { useCallback, useEffect, useState } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import postItemService from '../../../Axios/services/postItem.service';
import { removeDuplicateEvents } from '../../../helpers/helpers';
import { setCurrentCommunityId, setCurrentPage } from '../../../store/actions/mainActions';
import { FeedEventItem } from '../../content/Feed/FeedEventItem/FeedEventItem';
import FeedSessionItem from '../../content/Feed/FeedSessionItem/FeedSessionItem';
import FeedItem from '../../content/Feed/Post/FeedItem';
import SearchBox from '../../core/SearchBox/SearchBox';
import { BiCommentDetail as CommentIcon } from "react-icons/bi";
import { FiUsers as UsersIcon } from "react-icons/fi";
import temp_community_photo from '../../../../src/assets/images/temp-community-photo.jpeg';
import { useNavigate }   from 'react-router-dom';
import { useParams } from "react-router-dom";

const CommunityPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [filteredPosts, setFilteredPosts] = useState<PostItem[]>([]);
  const [posts, setPosts] = useState<PostItem[] | undefined>(undefined);
  const [searchInput, setSearchInput] = useState("");
  const [communities, setCommunities] = useState<any[]>([]);
  const { me } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (me?.userCommunities) {
      setCommunities(me.userCommunities);
    }
  }, [me?.userCommunities, setCommunities]);

  const onEnter = (e: any) => {
    navigate("/search/" + searchInput);
  };

  const searchHandler = (event: any) => {
    setSearchInput(event.target.value);
    if (event.target.value.length > 0) {
      const _filtered: PostItem[] = posts ? posts.filter((p: any) => p?.post.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1) : [];
      setFilteredPosts(_filtered);
    } else {
      if (posts) setFilteredPosts([...posts]);
    }
  };

  const fetchPosts = useCallback(async () => {
    if (id) {
      const _posts = await postItemService.getByCommunityId(id);
      const p = removeDuplicateEvents(_posts);
      setPosts(p);
      setFilteredPosts(p);
    }
  }, [setPosts, setFilteredPosts, me]);

  useEffect(() => {
    fetchPosts();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [fetchPosts]);

  useEffect(() => {
    dispatch(setCurrentCommunityId(id));
    dispatch(setCurrentPage("communityPage"));
    return () => {
      dispatch(setCurrentPage(""));
      dispatch(setCurrentCommunityId(null));
    };
  }, [dispatch]);

  // if (posts) {
  //     if (posts?.length > 0) {
  //         return (
  //             <div className="container-fluid px-md-1 px-0">

  //                 {communities.filter(communityRecord => communityRecord._id === id).map(community => (

  //                         <div className="community" key={community.id}>
  //                             <img className="community-photo" src={community.image ? community.image : temp_community_photo} alt="community" />
  //                             <div className="gradient"></div>
  //                             <div className="community-text w-100">
  //                                 <div className="community-name px-4">{community.communityName}</div>
  //                                 <div className="d-flex flex-wrap pt-3 align-items-end">
  //                                     <div className="community-description px-4 col-12 col-md-8">{community.description}</div>
  //                                     <div className="community-tabs col-12 col-md-4">
  //                                         <div className="tab">
  //                                             <CommentIcon className="icon" />
  //                                             <div className="number-bold">{community?.posts?.length ? community?.posts?.length : 0}</div>
  //                                             <div className="">Items</div>
  //                                         </div>
  //                                         <div className="tab">
  //                                             <UsersIcon className="icon" />
  //                                             <div className="number-bold">{community?.users?.length ? community?.users?.length : 0}</div>
  //                                             <div className="">Members</div>
  //                                         </div>
  //                                     </div>
  //                                 </div>
  //                             </div>
  //                         </div>

  //                 ))}

  //                 <div className="mx-md-0 mb-4 px-md-0 px-2">
  //                     <SearchBox
  //                         placeholder={'Find posts in community'}
  //                         changeHandler={searchHandler}
  //                         onEnter={onEnter}
  //                         value={searchInput}
  //                     />
  //                 </div>
  //                 {filteredPosts.map((post: any, index: number) => {
  //                     if (post?.eventContentItem && post?.sessionContentItem) {
  //                         return <>
  //                             <div key={index + 1}><FeedEventItem item={post}></FeedEventItem></div>
  //                             <div key={index + 2}><FeedSessionItem  item={post}></FeedSessionItem></div>
  //                         </>
  //                     } else if (post?.eventContentItem) {
  //                         return <div key={index}><FeedEventItem  item={post}></FeedEventItem></div>
  //                     } else if (post?.sessionContentItem) {
  //                         // return <div key={index+3}><FeedSessionItem history={history} item={post}></FeedSessionItem></div>
  //                     }
  //                     else {
  //                         return <div key={index+4}><FeedItem item={post} /></div>
  //                     }
  //                 })}
  //                 <div className="space"></div>
  //             </div>
  //         )

  //     } else {
  //         return <div className="row my-5">
  //             <div className="col-12">
  //                 No posts to show in this community
  //             </div>
  //         </div>
  //     }

  // } else {
  //     return Array.from(Array(4).keys()).map((e, i) => {
  //         return <div className="feed-item py-3 px-5" key={i}>
  //             <SkeletonTheme >
  //                 <div className="row flex-wrap">
  //                     <div className="col-2 d-flex justify-content-center">
  //                         <Skeleton circle={true} height={60} width={60} />
  //                     </div>
  //                     <div className="col-10">
  //                         <p className="m-0 p-0"><Skeleton height={10} width={150} /></p>
  //                         <p className="m-0 p-0"><Skeleton height={10} width={180} /></p>
  //                         <p className="m-0 p-0"><Skeleton height={10} width={80} /></p>
  //                     </div>
  //                 </div>
  //             </SkeletonTheme>
  //         </div>
  //     })
  // }

  return (
    <div className="container-fluid px-md-1 px-0">
      {posts && posts.length > 0 ? (
        <>
          {communities
            .filter((communityRecord) => communityRecord._id === id)
            .map((community) => (
              <div className="community" key={community.id}>
                <img className="community-photo" src={community.image || temp_community_photo} alt="community" />
                <div className="gradient"></div>
                <div className="community-text w-100">
                  <div className="community-name px-4">{community.communityName}</div>
                  <div className="d-flex flex-wrap pt-3 align-items-end">
                    <div className="community-description px-4 col-12 col-md-8">{community.description}</div>
                    <div className="community-tabs col-12 col-md-4">
                      <div className="tab">
                        <CommentIcon className="icon" />
                        <div className="number-bold">{community?.posts?.length || 0}</div>
                        <div className="">Items</div>
                      </div>
                      <div className="tab">
                        <UsersIcon className="icon" />
                        <div className="number-bold">{community?.users?.length || 0}</div>
                        <div className="">Members</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          <div className="mx-md-0 mb-4 px-md-0 px-2">
            <SearchBox placeholder="Find posts in community" changeHandler={searchHandler} onEnter={onEnter} value={searchInput} />
          </div>

          {filteredPosts.map((post, index) => (
            <div key={index}>
              {post?.eventContentItem && post?.sessionContentItem ? (
                <>
                  <FeedEventItem item={post} />
                  <FeedSessionItem item={post} />
                </>
              ) : post?.eventContentItem ? (
                <FeedEventItem item={post} />
              ) : post?.sessionContentItem ? (
                <FeedSessionItem item={post} />
              ) : (
                <FeedItem item={post} />
              )}
            </div>
          ))}
          <div className="space"></div>
        </>
      ) : posts ? (
        <div className="row my-5">
          <div className="col-12">No posts to show in this community</div>
        </div>
      ) : (
        Array.from(Array(4).keys()).map((_, i) => (
          <div className="feed-item py-3 px-5" key={i}>
            <SkeletonTheme>
              <div className="row flex-wrap">
                <div className="col-2 d-flex justify-content-center">
                  <Skeleton circle height={60} width={60} />
                </div>
                <div className="col-10">
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={150} />
                  </p>
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={180} />
                  </p>
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={80} />
                  </p>
                </div>
              </div>
            </SkeletonTheme>
          </div>
        ))
      )}
    </div>
  );
};

export default CommunityPage;


